module.exports = __webpack_public_path__ + "static/media/photostickomni-128.5618c01c.png";